import { render, staticRenderFns } from "./ArAnnounce.vue?vue&type=template&id=1aa88b5e&"
import script from "./ArAnnounce.vue?vue&type=script&lang=js&"
export * from "./ArAnnounce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports